/** Privacy policy body — adapted from https://www.jonesboothlaw.com/privacy-policy */
export const privacyPolicyTitle = 'Privacy Policy';

export const privacyPolicyBody = `
**Jones & Booth, LLC**

**Effective Date:** January 1, 2026

## Important Notice Regarding Text Messaging Data

Jones & Booth, LLC ("we," "us," or "our") DOES NOT share customer opt-in information, including phone numbers and consent records, with any affiliates or third parties for marketing, promotional, or any other purposes unrelated to providing our direct services. All text messaging originator opt-in data is kept strictly confidential.

## 1. Information We Collect

We collect the following types of information:

**Personal Information:**

- Name, email address, phone number, physical address
- Payment information when you make a purchase or request a quote
- Opt-in records and timestamps for all communication channels (SMS, email, etc.)

**Non-Personal Information:**

- IP address, browser type, device information
- Website usage patterns and analytics
- Cookies and similar technologies

**Customer Communication:**

- Records of inquiries and service requests
- Appointment details and preferences
- Service history and feedback

## 2. How We Use Your Information

We use collected data for:

- Providing and improving our services
- Processing transactions and payments
- Communicating with you about your inquiries, appointments, and promotions
- Enhancing website functionality and user experience
- Ensuring security and fraud prevention
- Maintaining records of your communication preferences and consent

## 3. SMS Messaging & Compliance

### Text Message Program Terms & Conditions

By opting into our SMS messaging services, you agree to receive text messages related to our services, including appointment reminders, customer support, and important updates.

**Opt-In & Consent:**

- You will only receive messages if you have explicitly opted in
- We maintain timestamped records of all opt-in actions
- We comply with the Telephone Consumer Protection Act (TCPA) and all applicable laws

**Opt-Out Instructions:**

- You can cancel SMS notifications at any time by replying "STOP"
- You will receive a final confirmation message, and no further messages will be sent unless you re-opt in
- All opt-out requests are processed immediately

**Message Frequency & Content:**

- Message frequency varies based on your interactions with our business
- Messages will be directly related to the services you have requested
- We do not send promotional content without specific consent

**Help & Support:**

- Reply "HELP" for assistance or contact us at admin@jonesboothlaw.com
- Customer support is available during regular business hours

**Carrier Information:**

- Standard message and data rates may apply
- Carriers are not liable for delayed or undelivered messages
- Supported carriers include AT&T, Verizon, T-Mobile, Sprint, and most regional carriers

### SMS Data Protection Statement

No mobile information will be shared with third parties/affiliates for marketing/promotional purposes. Information sharing to subcontractors in support services, such as customer service, is permitted. All other use case categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties.

We implement strict data protection measures to safeguard your SMS opt-in information and consent records.

## 4. Information Sharing & Disclosure

We do not sell, rent, or trade personal information. We may share information with:

**Service Providers:**

- Third-party vendors who assist in our operations (e.g., payment processing, appointment scheduling)
- SMS aggregators and providers solely for the purpose of delivering messages you've consented to receive
- All service providers are contractually obligated to maintain confidentiality and security

**Legal Compliance:**

- If required by law, legal process, or to protect our rights
- In response to valid law enforcement requests or court orders

**Business Transfers:**

- In case of mergers, acquisitions, or sale of assets
- In such cases, your data remains protected under the terms of this policy

All the above categories exclude text messaging originator opt-in data and consent; this information will not be shared with any third parties, excluding aggregators and providers of the Text Message services.

## 5. Data Security

We implement and maintain reasonable security measures to protect your personal information:

- Encryption of sensitive data in transit and at rest
- Secure access controls and authentication mechanisms
- Regular security assessments and updates
- Employee training on data protection
- Breach notification protocols in accordance with applicable laws
- Secure backup systems and disaster recovery procedures

Despite these measures, no method of transmission over the Internet or electronic storage is 100% secure. We strive to use commercially acceptable means to protect your personal information but cannot guarantee absolute security.

## 6. Cookies & Tracking Technologies

We use cookies and similar technologies to:

- Analyze site traffic and user behavior
- Remember your preferences
- Improve website functionality and user experience
- Measure the effectiveness of our services

You may control cookies through your browser settings. Disabling cookies may limit your ability to use certain features of our website.

## 7. Your Rights & Choices

You have the right to:

- Access, update, or delete your personal information
- Opt-out of marketing emails by clicking "unsubscribe" in our emails
- Opt-out of SMS messages by replying "STOP"
- Request information on how we process your data
- Withdraw consent at any time for future communications
- Lodge a complaint with a supervisory authority if you believe your rights have been violated

To exercise these rights, please contact us using the information in Section 10.

## 8. Third-Party Links

Our website may contain links to third-party websites. We are not responsible for their privacy practices and encourage you to review their policies. This privacy policy applies only to information collected by Jones & Booth, LLC.

## 9. Changes to This Privacy Policy

We may update this policy periodically. The latest version will always be available on our website with the effective date. For significant changes, we will notify you by email or through a notice on our website.

## 10. Contact Us

If you have questions about this Privacy Policy or how your information is handled, contact us at:

**Jones & Booth, LLC**

Phone: 470-359-9972  
Email: admin@jonesboothlaw.com  
Website: jonesboothlaw.com

By using our website and services, you consent to this Privacy Policy.
`.trim();
